import { AuthFetchWithResponse } from 'src/Types/api'
import { ApiResult } from 'src/Libs/api'
import { StatusCodes } from 'src/Libs/http-status-codes'

import { UserPermissionTypes } from '../types'

export type EnablePermissionsPayload = Record<UserPermissionTypes, boolean>

/**
 * Using to enable permissions for user in company
 *
 * @param companyId
 * @param userId
 * @param payload
 * @param authFetch
 */
export const enablePermissions = async (
  companyId: number,
  userId: number,
  payload: EnablePermissionsPayload,
  authFetch: AuthFetchWithResponse
): Promise<ApiResult<void, unknown>> => {
  const response = await authFetch({
    path: `users/companies/${companyId}/users/${userId}`,
    method: 'POST',
    payload,
  })

  if (response.status !== StatusCodes.CREATED) {
    return new ApiResult(null, true)
  }
  return new ApiResult(null, false)
}

/**
 * Using to remove permissions from user in company
 *
 * @param companyId
 * @param userId
 * @param permissionType
 * @param authFetch
 */
export const removePermission = async (
  companyId: number,
  userId: number,
  permissionType: UserPermissionTypes,
  authFetch: AuthFetchWithResponse
): Promise<ApiResult<void, unknown>> => {
  const response = await authFetch({
    path: `users/companies/${companyId}/users/${userId}/${permissionType}`,
    method: 'DELETE',
  })

  if (response.status !== StatusCodes.NO_CONTENT) {
    return new ApiResult(null, true)
  }
  return new ApiResult(null, false)
}
